module.exports = __webpack_public_path__ + "static/media/pageview-icon.650d7ed8.svg";